/* 用户端专属 mutation type */

export const AJAX_GET_USERINFO = 'AJAX_GET_USERINFO'; // 用户信息
export const AJAX_BUY_INFO = 'AJAX_BUY_INFO'; // 下单信息
export const AJAX_PAY_INFO = 'AJAX_PAY_INFO'; // 支付信息
export const AJAX_ORDER_INFO = 'AJAX_ORDER_INFO'; // 支付信息
export const WX_PAY = 'WX_PAY';     // 微信支付
export const MY_PAY = 'MY_PAY';     // 支付宝支付
export const CLEAR_PAY_STATUS = 'CLEAR_PAY_STATUS';     // 清除支付状态
export const TREE_COIN_INFO = 'TREE_COIN_INFO'; // 获取树币
export const TREE_COIN_INFO_MORE = 'TREE_COIN_INFO_MORE'; // 加载更多
export const AJAX_HOT_LABEL_LIST = 'AJAX_HOT_LABEL_LIST';

// 用户端
export const AJAX_GET_CATAGORY = 'AJAX_GET_CATAGORY'; // 获取首页分类
export const AJAX_GET_INDEXLIST = 'AJAX_GET_INDEXLIST'; // 获取首页列表
export const AJAX_POST_ADDCOMMENT = 'AJAX_POST_ADDCOMMENT'; // 评论信息
export const AJAX_GET_USER_ISSUES = 'AJAX_GET_USER_ISSUES';       // 获取课堂页问题列表
export const AJAX_GET_USERCOURSE = 'AJAX_GET_USERCOURSE'; // 获取我的开讲列表
export const AJAX_GET_COMBINECOURSE = 'AJAX_GET_COMBINECOURSE'; // 获取我的组合课
export const AJAX_POST_USERSENDCODE = 'AJAX_POST_USERSENDCODE'; // 获取短信验证码
export const AJAX_POST_USERBINDING = 'AJAX_POST_USERBINDING'; // 获取短信验证码
export const AJAX_GET_MYTINYAUDIO = 'AJAX_GET_MYTINYAUDIO'; // 获取我的音频列表
export const AJAX_GET_MYTINYVIDEO = 'AJAX_GET_MYTINYVIDEO'; // 获取我的视频列表
export const AJAX_GET_MYTINYALBUM = 'AJAX_GET_MYTINYALBUM'; // 获取我的音频专辑列表
export const AJAX_GET_MYTINYVIDEOALBUM = 'AJAX_GET_MYTINYVIDEOALBUM'; // 获取我的视频专辑列表
export const AJAX_GET_SERIALCOURSEINFO = 'AJAX_GET_SERIALCOURSEINFO'; // 获取系列课详情
export const AJAX_GET_LAMA_RECOMMEND = 'AJAX_GET_LAMA_RECOMMEND'; // 获取更多免费推荐课程
export const AJAX_GET_FREETINYAUDIO = 'AJAX_GET_FREETINYAUDIO'; // 获取免费小微课
export const AJAX_GET_GROUPALBUM = 'AJAX_GET_GROUPALBUM'; // 组合课程列表
export const AJAX_GET_MYCOURSE = 'AJAX_GET_MYCOURSE'; // 我的课程列表
export const AJAX_GET_COLUMNLIST = 'AJAX_GET_COLUMNLIST'; // 订阅课列表

//  声音相关
export const AJAX_UPDATE_AUDIO5 = 'AJAX_UPDATE_AUDIO5'; // audio5 对象

// 收银台
export const CASHIER_PAY = 'CASHIER_PAY'; // 系列课列表

export const HOME_INFO = 'HOME_INFO'; // 首页数据
export const RECOMMEND_LIST = 'RECOMMEND_LIST'; // 首页数据
export const COURSE_REMIND = 'COURSE_REMIND'; // 首页提示条信息
export const REMIND_CLOSE = 'REMIND_CLOSE'; // 首页提示条状态
export const CHANGE_HOTCOURSE = 'CHANGE_HOTCOURSE'; // 首页热门开讲

export const IS_SORT = 'IS_SORT'; // 订阅课子课程列表排序
export const MESSAGE_LIST = 'MESSAGE_LIST'; // 订阅课子课程留言列表

// 新版课程详情
export const AJAX_GET_NEWCOURSEINFO = 'AJAX_GET_NEWCOURSEINFO';  // 获取新版课程详情
export const AJAX_GET_MY_INCOME = 'AJAX_GET_MY_INCOME';  // 我的收益

// 获取后台配置的静态数据
export const AJAX_GET_CONSTANT_DATA = 'AJAX_GET_CONSTANT_DATA';  // 获取后台配置的静态数据
export const VIP_INFO = 'VIP_INFO';  // vip静态数据

export const AJAX_GET_MEMBER_FREE_COURSE = 'AJAX_GET_MEMBER_FREE_COURSE';  // 会员免费听
export const INDEX_MODULE_LIST = 'INDEX_MODULE_LIST';  // 新版首页 模块列表 2018-6-21

// 专家义诊
export const FREE_ANS_COUNT = 'FREE_ANS_COUNT';   // 专家义诊专家可回答的免费问题数



// WEBPACK FOOTER //
// ./src/store/user/mutation-types.user.js